export const hoSoSurveyStatus = {
    isLoading: 'is_loading',
    isCompleted: 'is_completed',
    isSaving: 'is_saving',
};

export const hoSoSurveyIniState = {
    status: hoSoSurveyStatus.isCompleted,
    ts_hoso_surveys: [],
    ts_hoso_survey_editing_id: 0,
    ts_hoso_survey_status_id: -1,
    ts_hoso_survey_selected_ids: [],
    is_show_update_status_model: false,
    is_show_detail_modal: false
}
export const hoSoSurveyActionTypes = {
    BEGIN_LOAD_HOSO: "BEGIN_LOAD_HOSO",
    SUCCESS_LOAD_HOSO: "SUCCESS_LOAD_HOSO",
    ERROR_LOAD_HOSO: "ERROR_LOAD_HOSO",

    CHANGE_FILTER_STATUS_ID: "CHANGE_FILTER_STATUS_ID",
    CHANGE_SELECTED_IDS: "CHANGE_SELECTED_IDS",

    SHOW_UPDATE_STATUS_MODAL: "SHOW_UPDATE_STATUS_MODAL",
    CLOSE_UPDATE_STATUS_MODAL: "CLOSE_UPDATE_STATUS_MODAL",

    SHOW_DETAIL_MODAL: "SHOW_DETAIL_MODAL",
    CLOSE_DETAIL_MODAL: "CLOSE_DETAIL_MODAL",

    SET_HOSO_EDITING_ID: "SET_HOSO_EDITING_ID:"
}

export const hoSoSurveyReducer = (state, action) => {
    switch (action.type) {
        case hoSoSurveyActionTypes.BEGIN_LOAD_HOSO:
            return {
                ...state,
                status: hoSoSurveyStatus.isLoading
            };
        case hoSoSurveyActionTypes.SUCCESS_LOAD_HOSO:
            return {
                ...state,
                status: hoSoSurveyStatus.isCompleted,
                ts_hoso_surveys: action.payload
            };
        case hoSoSurveyActionTypes.ERROR_LOAD_HOSO:
            return {
                ...state,
                status: hoSoSurveyStatus.isCompleted,
                ts_hoso_surveys: []
            };
        case hoSoSurveyActionTypes.CHANGE_FILTER_STATUS_ID:
            return {
                ...state,
                ts_hoso_survey_status_id: action.payload
            };
        case hoSoSurveyActionTypes.CHANGE_SELECTED_IDS:
            return {
                ...state,
                ts_hoso_survey_selected_ids: action.payload
            };
        case hoSoSurveyActionTypes.SHOW_UPDATE_STATUS_MODAL:
            return {
                ...state,
                is_show_update_status_model: true
            };
        case hoSoSurveyActionTypes.CLOSE_UPDATE_STATUS_MODAL:
            return {
                ...state,
                is_show_update_status_model: false
            };

        case hoSoSurveyActionTypes.SHOW_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: true
            };

        case hoSoSurveyActionTypes.CLOSE_DETAIL_MODAL:
            return {
                ...state,
                is_show_detail_modal: false
            };
        case hoSoSurveyActionTypes.SET_HOSO_EDITING_ID:
            return {
                ...state,
                ts_hoso_survey_editing_id: action.payload
            };
        default:
            return state
    }
}